import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allUsuEntPerfilesAction,
  setActivoUsuEntPerfilesAction,
} from './UsuEntPerfilesAction';
import FormUsuEntPerfiles from './components/FormUsuEntPerfiles';
import ListadoUsuEntPerfiles from './components/ListadoUsuEntPerfiles';

const UsuEntPerfilesView = () => {
  const dispatch = Redux.useDispatch();

  // const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);
  const usuEntPerfilesStore = Redux.useSelector(
    (state) => state.usuEntPerfiles,
  );

  // const isStudent = usuEntidadesStore.activo.usuario.rol === STUDENT_CONST;
  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoUsuEntPerfilesAction(dispatch, null);
            setOpenModalForm(!openModalForm);
          }}
          green
          mr={2}
          addIcon
          text="Asignar"
        />

        <BotonComponent
          click={async () => {
            await setActivoUsuEntPerfilesAction(dispatch, null);
            await allUsuEntPerfilesAction(dispatch, usuEntPerfilesStore.params);
          }}
          disabled={
            usuEntPerfilesStore.all.length === 0 ||
            usuEntPerfilesStore.loadingAll
          }
          white
          refreshIcon
          text={
            usuEntPerfilesStore.loadingAll ? 'Actualizando...' : 'Actualizar'
          }
        />
      </Grid>
      <Grid item md={12}>
        <ListadoUsuEntPerfiles />
      </Grid>
      <ModalComponent
        id="modalFormPermisos"
        title={`${usuEntPerfilesStore.activo ? 'Editar' : 'Asignar'} perfil`}
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
        maxWidth="sm"
      >
        <FormUsuEntPerfiles setOpenModalForm={(val) => setOpenModalForm(val)} />
      </ModalComponent>
    </Grid>
  );
};

export default UsuEntPerfilesView;
